function updateHeaderHeight() {
  document.documentElement.style.setProperty(
    '--not-stickty-header-height',
    document.querySelector('.header-wrapper').offsetHeight + 'px'
  );
}
window.addEventListener('load', updateHeaderHeight);
window.addEventListener('resize', updateHeaderHeight);

document.addEventListener('DOMContentLoaded', function () {
  const customSelects = document.querySelectorAll('.custom-select');
  customSelects.forEach((customSelect) => {
    const trigger = customSelect.querySelector('.custom-select-trigger');
    const options = customSelect.querySelectorAll('.custom-options .custom-option');
    const selectedCountrySpan = trigger.querySelector('.selected_country');
    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      const isOpen = customSelect.classList.contains('open');
      closeAllSelects();
      if (!isOpen) {
        customSelect.classList.add('open');
      }
    });
    options.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();
        const selectedImageSrc = this.querySelector('.countryimage img').getAttribute('src');
        trigger.querySelector('img').setAttribute('src', selectedImageSrc);
        trigger.querySelector('img').setAttribute('srcset', selectedImageSrc);
        const selectedCountryName = this.getAttribute('data-name');
        selectedCountrySpan.textContent = selectedCountryName;
        customSelect.classList.remove('open');
      });
    });
  });
  document.addEventListener('click', function (event) {
    closeAllSelects();
  });
  function closeAllSelects() {
    customSelects.forEach((customSelect) => {
      customSelect.classList.remove('open');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.outfit-tab-button');
  const tabContents = document.querySelectorAll('.outfit-tab-content');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');

      if (document.querySelector('.outfit-tab-button.active')) {
        document.querySelector('.outfit-tab-button.active').classList.remove('active');
      }
      if (document.querySelector('.outfit-tab-content.active')) {
        document.querySelector('.outfit-tab-content.active').classList.remove('active');
      }
      button.classList.add('active');
      document.getElementById(targetTab).classList.add('active');
      if (document.querySelector(`[data-tabid="${targetTab}"]`)) {
          document.getElementById(targetTab).innerHTML = document.querySelector(
            `[data-tabid="${targetTab}"]`
          ).innerHTML;
      }
      main_pro_card_slider();
      product_images_slider();
      scrollToClosestActive(targetTab);
      main_pro_card_slider_outfit();
      morecolorShow();
    });
  });
});

function scrollToClosestActive(targetTab) {
  setTimeout(() => {
    window.scrollTo({
      top: document.getElementById(targetTab).offsetTop,
      behavior: 'smooth'
    });
  }, 200);
}

document.addEventListener('DOMContentLoaded', function () {
  const mySwiper = new Swiper('.outfit-tabs-bottom-slider', {
    spaceBetween: 8,
    slidesPerView: 4,
    roundLengths: true,
    loop: true,
    breakpoints: {
      749: {
        slidesPerView: 2.09,
        spaceBetween: 8
      }
    },
    navigation: {
      nextEl: '.outfit-tabs-next',
      prevEl: '.outfit-tabs-prev'
    },
    on: {
      slideChange: function () {
        if (window.innerWidth <= 749 && this.slides[this.activeIndex]) {
          this.slides[this.activeIndex].querySelector('.outfit-tab-button').click();
        }
      }
    }
  });
});
function main_pro_card_slider() {
  document
    .querySelectorAll('.outfit-tab-content.active .outfit-tabs-product-slider-lookbook')
    .forEach(function (slider) {
      const parent = slider.closest('.main_pro_card_slider-lookbook');
      const nextEl = parent.querySelectorAll('.mainslide-next');
      const prevEl = parent.querySelectorAll('.mainslide-prev');
      new Swiper(slider, {
        spaceBetween: 8,
        slidesPerView: 1,
        roundLengths: true,
        loop: false,
        observer: true,
        observeParents: true,
        breakpoints: {
          749: {
            slidesPerView: 2.05,
            spaceBetween: 0
          }
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        pagination: {
          el: parent.querySelectorAll('.swiper-pagination'),
          clickable: true
        }
      });
    });
}
document.addEventListener('DOMContentLoaded', function () {
  main_pro_card_slider_outfit();
});
function main_pro_card_slider_outfit() {
  document.querySelectorAll('.outfit-tab-content.active .outfit-tabs-product-slider').forEach(function (slider) {
    new Swiper(slider, {
      spaceBetween: 8,
      slidesPerView: 1,
      roundLengths: true,
      loop: true,
      breakpoints: {
        749: {
          slidesPerView: 2.04,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: slider.closest('.main_pro_card_slider').querySelectorAll('.mainslide-next'),
        prevEl: slider.closest('.main_pro_card_slider').querySelectorAll('.mainslide-prev')
      },
      pagination: {
        el: slider.closest('.main_pro_card_slider').querySelectorAll('.swiper-pagination-main'),
        clickable: true
      },
      on: {
        slideChange: function () {
          this.pagination.render();
          this.pagination.update();
          handleSwiper();
        }
      }
    });
  });
}
function handleSwiper() {
  const sliderWrapper = document.querySelector('[js-featured-collection="slider-container"]');
  const swiperContainers = document.querySelectorAll('.prod-images-slider');

  if (!sliderWrapper || !sliderWrapper.hasAttribute('gallery-swiper-mobile')) {
    swiperContainers.forEach((container) => {
      if (!container.swiper) {
        container.swiper = initSwiper(container);
      }
    });
    return;
  }

  swiperContainers.forEach((container) => {
    let swiperInstance = container.swiper;

    if (window.innerWidth >= 1024) {
      if (!swiperInstance) {
        container.swiper = initSwiper(container);
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        container.swiper = null;
      }
    }
  });
}

function initSwiper(container) {
  const parent = container.closest('.card__media');
  const paginationEl = parent.querySelector('.swiper-pagination');
  const nextEl = parent.querySelector('.images_sliderbtn.swiper-button-next');
  const prevEl = parent.querySelector('.images_sliderbtn.swiper-button-prev');
  const swiper = new Swiper(container, {
    loop: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    breakpoints: {
      749: {
        allowTouchMove: !document.body.classList.contains('product'),
      }
    },
    pagination: {
      el: paginationEl,
      clickable: true
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl
    }
  });
  swiper.on('slideChange', function () {
    swiper.pagination.render();
    swiper.pagination.update();
  });
  return swiper;
}

document.addEventListener('DOMContentLoaded', function () {
  handleSwiper();
  window.addEventListener('resize', debounce(handleSwiper, 300));
});
function product_images_slider() {
  const swiperContainers = document.querySelectorAll('.outfit-tab-content.active .prod-images-slider-lookbook');
  swiperContainers.forEach(function (container) {
    const parent = container.closest('.card__media');
    const paginationEl = parent.querySelector('.swiper-pagination');
    const nextEl = parent.querySelector('.images_sliderbtn.swiper-button-next');
    const prevEl = parent.querySelector('.images_sliderbtn.swiper-button-prev');
    const swiper = new Swiper(container, {
      loop: true,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      breakpoints: {
        749: {
          allowTouchMove: false
        }
      },
      pagination: {
        el: paginationEl,
        clickable: true
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      }
    });
    swiper.on('slideChange', function () {
      swiper.pagination.render();
      swiper.pagination.update();
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  const mySwiper = new Swiper('.drawer_products', {
    spaceBetween: 8,
    slidesPerView: 1,
    roundLengths: true,
    loop: true,
    breakpoints: {
      749: {
        slidesPerView: 1,
        spaceBetween: 8
      }
    },
    navigation: {
      nextEl: '.drawer-btn-next',
      prevEl: '.drawer-btn-prev'
    }
  });
});

function toggleDescription() {
  document.querySelector('.mobile_sort_description').style.display = 'none';
  document.querySelector('.mobile_full_description').style.display = 'block';
  document.querySelector('.readmore').style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.color_opt')) {
    document.querySelector('.color_opt').innerHTML = ' ' + document.querySelector('.color_select').value;
    document.querySelector(
      '.color-variants-wrapper input[value="' + document.querySelector('.color_select').value + '"]'
    ).checked = true;
    document.querySelectorAll('input[name="radio-color-group"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        document.querySelector('.color_opt').innerHTML = ' ' + this.value;
        document.querySelector('.color_select').value = this.value;
        const event = new Event('change', {
          bubbles: true
        });
        document.querySelector('.color_select').dispatchEvent(event);
      });
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.buy_buttons_text') && document.querySelector('.buy_buttons_text .product-form')) {
    window.addEventListener('scroll', function () {
      if (window.scrollY >= document.querySelector('.buy_buttons_text .product-form').offsetHeight + 150) {
        document.querySelector('.buy_buttons_text').classList.remove('sticky');
      } else {
        document.querySelector('.buy_buttons_text').classList.add('sticky');
      }
    });
  }
});
function editQty() {
  document.querySelectorAll('span.editbtn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.cart-item quantity-popover').forEach(function (prover) {
        if (prover.closest('.cart_items')) {
          prover.classList.add('hide');
        }
      });
      document.querySelectorAll('.cart-item .itemqty').forEach(function (itemqty) {
        itemqty.classList.remove('hide');
      });
      const cartItem = btn.closest('.cart-item');
      if (cartItem && cartItem.querySelector('quantity-popover')) {
        cartItem.querySelector('quantity-popover').classList.remove('hide');
        cartItem.querySelector('.itemqty').classList.add('hide');
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.outlook_image_slide_prev').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('.outfit-tabs-bottom-slider .outfit-tabs-prev').click();
    });
  });
  document.querySelectorAll('.outlook_image_slide_next').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('.outfit-tabs-bottom-slider .outfit-tabs-next').click();
    });
  });
});

document.addEventListener('DOMContentLoaded', klarnaStyle);
function klarnaStyle() {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('klarna-placement').forEach((klarnaPlacement) => {
      if (klarnaPlacement.shadowRoot) {
        const shadowRoot = klarnaPlacement.shadowRoot;
        const shadowObserver = new MutationObserver(() => {
          applyStyles(shadowRoot, klarnaPlacement, observer, shadowObserver);
        });
        shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
        applyStyles(shadowRoot, klarnaPlacement, observer, shadowObserver);
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
}
function applyStyles(shadowRoot, klarnaPlacement, mainObserver, shadowObserver) {
  const styles = [
    {
      selector: '.container',
      styles: { borderColor: 'transparent', padding: '0', alignItems: 'flex-start', justifyContent: 'center' }
    },
    { selector: '#osm-klarna-title', styles: { width: '47px', borderRadius: '4px', backgroundColor: '#ffa8cd' } },
    {
      selector: '.text-wrapper',
      styles: { fontSize: '10px', marginLeft: '10px', fontWeight: '700', lineHeight: '11px', letterSpacing: '0' }
    },
    {
      selector: 'button.link',
      styles: { fontSize: '10px', fontWeight: '700', lineHeight: '11px', letterSpacing: '0.02em', marginLeft: '2px' }
    },
    {
      selector: '.legal',
      styles: { fontSize: '10px', color: '#0B0B0B', fontWeight: '400', lineHeight: '11px', letterSpacing: '0.02em' }
    }
  ];
  let allSelectorsApplied = true;
  styles.forEach(({ selector, styles }) => {
    const element = shadowRoot.querySelector(selector);
    if (element) {
      Object.assign(element.style, styles);
    } else {
      allSelectorsApplied = false;
    }
  });
  if (allSelectorsApplied) {
    if (klarnaPlacement.classList.contains('hide')) {
      klarnaPlacement.classList.remove('hide');
    }
    mainObserver.disconnect();
    shadowObserver.disconnect();
  }
}
document.querySelector('.header__icon--search').addEventListener('click', function () {
  document.querySelector('.search__input.field__input').blur();
});
document.querySelector('.search-modal__form').addEventListener('touchmove', (event) => {
  document.getElementById('Search-In-Modal').blur();
});
document.querySelector('.search-modal__form').addEventListener('scroll', (event) => {
  document.getElementById('Search-In-Modal').blur();
});
